import { render, staticRenderFns } from "./UploadPhotoDialog.vue?vue&type=template&id=28a2bcd8&"
import script from "./UploadPhotoDialog.vue?vue&type=script&lang=js&"
export * from "./UploadPhotoDialog.vue?vue&type=script&lang=js&"
import style0 from "./UploadPhotoDialog.vue?vue&type=style&index=0&lang=stylus&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports